var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
var CheckIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M17.7791137,8.62829359 C17.3296134,8.27878591 16.6796611,8.31055933 16.2666066,8.72361387 L16.2666066,8.72361387 L11.0007823,13.9891047 L8.16718895,11.1535815 L8.05924304,11.0582613 C7.6097427,10.7087536 6.95979044,10.740527 6.5467359,11.1535815 C6.09926015,11.6010573 6.09926015,12.3265588 6.5467359,12.7740346 L6.5467359,12.7740346 L10.1916874,16.4189861 L10.2996333,16.5143064 C10.7491337,16.863814 11.3990859,16.8320406 11.8121404,16.4189861 L11.8121404,16.4189861 L17.8870596,10.3440669 L17.9823799,10.236121 C18.3318876,9.78662066 18.3001142,9.13666841 17.8870596,8.72361387 L17.8870596,8.72361387 Z" }))); };
export default CheckIcon;
